const middleware = {}

middleware['event'] = require('../middleware/event.ts')
middleware['event'] = middleware['event'].default || middleware['event']

export default middleware
